import { numericalInputStyles } from '../../../../styles/mainStyle';
import { PropertyCaption } from '../../PropertyCaption';
import { PropertyNumericalInput } from '../../PropertyNumericalInput';

import type { ControlRenderProps, NumberControlSetting } from '../ControlTypes';

export const NumberControl = ({
  control,
  modifyProperty,
  unifiedValue,
}: ControlRenderProps<NumberControlSetting>) => {
  const numDefault =
    typeof unifiedValue === 'number' ? unifiedValue : undefined;

  return (
    <>
      <PropertyCaption>{control.label}</PropertyCaption>
      <PropertyNumericalInput
        propertyName={control.property}
        defaultValue={numDefault}
        unit={control.unit}
        customStyles={numericalInputStyles}
        getInputValue={async (
          _property: string,
          _value: string,
          valueFormatted: string,
        ) => {
          modifyProperty(
            control.elementPaths,
            control.property,
            valueFormatted,
          );
        }}
      />
    </>
  );
};
